/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceAccessTagsSetRequest
 */
export interface DeviceAccessTagsSetRequest {
    /**
     *
     * @type {number}
     * @memberof DeviceAccessTagsSetRequest
     */
    deviceArchiveId?: number;
    /**
     * True to update all child devices of a Wave at the same time
     * @type {boolean}
     * @memberof DeviceAccessTagsSetRequest
     */
    cascadeToChildDevices?: boolean;
    /**
     *
     * @type {Array<string>}
     * @memberof DeviceAccessTagsSetRequest
     */
    accessTags?: Array<string>;
}

/**
 * Check if a given object implements the DeviceAccessTagsSetRequest interface.
 */
export function instanceOfDeviceAccessTagsSetRequest(
    value: object,
): value is DeviceAccessTagsSetRequest {
    return true;
}

export function DeviceAccessTagsSetRequestFromJSON(
    json: any,
): DeviceAccessTagsSetRequest {
    return DeviceAccessTagsSetRequestFromJSONTyped(json, false);
}

export function DeviceAccessTagsSetRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceAccessTagsSetRequest {
    if (json == null) {
        return json;
    }
    return {
        deviceArchiveId:
            json["deviceArchiveId"] == null
                ? undefined
                : json["deviceArchiveId"],
        cascadeToChildDevices:
            json["cascadeToChildDevices"] == null
                ? undefined
                : json["cascadeToChildDevices"],
        accessTags: json["accessTags"] == null ? undefined : json["accessTags"],
    };
}

export function DeviceAccessTagsSetRequestToJSON(
    value?: DeviceAccessTagsSetRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceArchiveId: value["deviceArchiveId"],
        cascadeToChildDevices: value["cascadeToChildDevices"],
        accessTags: value["accessTags"],
    };
}
